import { Box, Button, Typography } from "@mui/material";

// Previous/Next over one server page of CSV lines; both stay disabled while
// a page is loading, so only one page request is ever in flight.
const CsvPager = ({ pages, pageSize }) => {
  const {
    lines,
    isLoading,
    pageNumber,
    hasNext,
    hasPrevious,
    goNext,
    goPrevious
  } = pages;
  const firstRow = (pageNumber - 1) * pageSize + 1;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: "auto" }}>
      <Typography variant="caption" color="textSecondary">
        {lines.length
          ? `Showing ${firstRow}–${firstRow + lines.length - 1}`
          : "Nothing to show"}
      </Typography>
      <Button
        size="small"
        disabled={isLoading || !hasPrevious}
        onClick={goPrevious}
      >
        Previous
      </Button>
      <Button size="small" disabled={isLoading || !hasNext} onClick={goNext}>
        Next
      </Button>
    </Box>
  );
};

export default CsvPager;
